import { createAction } from "redux-actions";

import { addToast } from "./toasts";

const storeReplication = createAction("STORE_REPLICATION");

// Same-origin path proxied by nginx (prod) or setupProxy.js (dev), which add
// the X-Api-Key header server-side so no secret ships in the JS bundle.
const ENDPOINT = "/replication-api";
const url = "/replications";

export const showReplication = createAction("API_SHOW_REPLICATION", () => ({
  method: "GET",
  baseURL: ENDPOINT,
  url,
  onSuccessAction: storeReplication
}));

export const triggerReplication = createAction("API_TRIGGER_REPLICATION", () => ({
  method: "POST",
  baseURL: ENDPOINT,
  url,
  onSuccessActions: [
    storeReplication,
    () => addToast("success", "Success", "Successfully triggered replication")
  ]
}));
